import { productBySlug } from "@/lib/catalog";

export type OfferteProduct = { productnaam: string; type_opdracht: string; prijs?: string };
export const PRODUCTEN_OFFERTE: Record<string, OfferteProduct> = {
  "aeg-3fase-groepenkast": {
    // Zonder prijstekst: op de website wordt geen prijs getoond (o.a. in de wizard-kaart).
    productnaam: "AEG 3Fase Groepenkast | 4 groepen | 1 kookgroep | 3 aardlekschakelaars",
    type_opdracht: "Groepenkast aanleggen of uitbreiden",
  },
  "groepenkast": { productnaam: "AEG groepenkast op maat", type_opdracht: "Groepenkast aanleggen of uitbreiden" },
  "camerabewaking": { productnaam: "Camerasysteem op maat", type_opdracht: "Camerabeveiliging" },
  "laadpaal": { productnaam: "Laadpaal inclusief installatie", type_opdracht: "Laadpaal installeren" },
};

export function offerteProduct(slug?: string): OfferteProduct | null {
  if (!slug) return null;
  const registered = PRODUCTEN_OFFERTE[slug];
  if (registered) return registered;
  const product = productBySlug(slug);
  if (!product) return null;
  const category = `${product.category_label} ${product.name}`.toLowerCase();
  const type_opdracht = /camera|hikvision|dahua|nvr/.test(category) ? "Camerabeveiliging"
    : /groepenkast/.test(category) ? "Groepenkast aanleggen of uitbreiden"
    : /laadpaal/.test(category) ? "Laadpaal installeren"
    : /netwerk|access point|kabel/.test(category) ? "Databekabeling aanleggen" : "Elektra aanleggen";
  return { productnaam: product.name, type_opdracht };
}